import * as Sentry from '@sentry/browser';
import axiosBetterStacktrace from 'axios-better-stacktrace';
import { REQUEST_ID_HEADER } from './client_consts.esm.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var REQUEST_CANCELLED_STATUS = 0;
function axiosCommonErrorInterceptor(error) {
    return _axiosCommonErrorInterceptor.apply(this, arguments);
}
function _axiosCommonErrorInterceptor() {
    _axiosCommonErrorInterceptor = _async_to_generator(function(error) {
        var response, _ref, status, config, headers, _ref1, _ref_url, url, _ref_method, method, _response_status, _headers_REQUEST_ID_HEADER;
        return _ts_generator(this, function(_state) {
            response = error.response;
            _ref = response !== null && response !== void 0 ? response : {
                status: 0,
                headers: {}
            }, status = _ref.status, config = _ref.config, headers = _ref.headers;
            _ref1 = config !== null && config !== void 0 ? config : {}, _ref_url = _ref1.url, url = _ref_url === void 0 ? "unknown" : _ref_url, _ref_method = _ref1.method, method = _ref_method === void 0 ? "UNKNOWN" : _ref_method;
            if (status > REQUEST_CANCELLED_STATUS) {
                error.message = "HTTP error ".concat((_response_status = response === null || response === void 0 ? void 0 : response.status) !== null && _response_status !== void 0 ? _response_status : "unknown", " for url: ").concat(method.toUpperCase(), " ").concat(url);
                Sentry.captureException(error, {
                    tags: {
                        requestId: (_headers_REQUEST_ID_HEADER = headers[REQUEST_ID_HEADER]) !== null && _headers_REQUEST_ID_HEADER !== void 0 ? _headers_REQUEST_ID_HEADER : headers[REQUEST_ID_HEADER.toUpperCase()],
                        status: status.toString()
                    }
                });
            }
            throw error;
        });
    });
    return _axiosCommonErrorInterceptor.apply(this, arguments);
}
function setupAxiosCommonErrorInterceptor(axiosInstance) {
    axiosBetterStacktrace(axiosInstance); // eslint-disable-line @typescript-eslint/no-unsafe-call
    axiosInstance.interceptors.response.use(function(response) {
        return response;
    }, axiosCommonErrorInterceptor);
}

export { REQUEST_CANCELLED_STATUS, axiosCommonErrorInterceptor, setupAxiosCommonErrorInterceptor };
